// Document
export enum TimetableMode {
  STUDENTS_MANUAL = 0,
  STUDENTS_AUTOMATIC = 1,
  TIMETABLE_MANUAL = 2
}
